<template>
  <v-card class="playlist-panel overflow-y-auto">
    <v-card-title>
      Playlist <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-btn color="error" class="mr-4" small @click="abort"> Cancelar </v-btn>
      <v-btn color="success" class="mr-4" small @click="save" :disabled="!valid">
        Salvar
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field outlined label="Nome da playlist" v-model="name" :rules="[
        (v) =>
          v.length > 0 ||
          'Preencha um nome para esta playlist ex: playlist do dia 01/01/2021',
      ]" required small></v-text-field>

        <v-select small outlined label="Tipo" :items="['Regiões', 'Totens']" v-model="type"
          :rules="[(v) => v.length > 0 || 'Tipo é obrigatório']"></v-select>

        <v-autocomplete
          v-model="selectedLetreiro"
          :items="filteredLetreiros"
          :loading="loadingLetreiros"
          :search-input.sync="searchLetreiro"
          item-text="name"
          item-value="_id"
          label="Buscar letreiro (opcional)"
          placeholder="Digite para buscar letreiros..."
          outlined
          clearable
          no-data-text="Nenhum letreiro encontrado"
          return-object
          small
          @focus="handleLetreiroFocus"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ truncateText(item.text) }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-form>

    </v-card-text>
    <v-card-text>
      <div class="font-weight-bold ml-8 mb-2">
        Linha do tempo ~
        {{
        $store.state.playlist.itemsSelected.reduce(
          (acc, item) => (acc += item.time),
          0
        )
      }}
        segundos
      </div>

      <v-timeline align-top dense>
        <drop-list :items="$store.state.playlist.itemsSelected" class="item-action" @insert="onInsert"
          @reorder="reorder">
          <template v-slot:item="{ item }">
            <drag class="item" :key="item._id">
              <div v-if="item.text == 1 &&
        $store.state.playlist.itemsSelected.length == 1
        " style="height: 200px">
                Arraste o ítem ao lado
              </div>
              <timeline-item v-if="item.text != 1" :item="item" :has-letreiro-selected="!!selectedLetreiro">
                <!-- <template v-slot:activator="{ on }">fasdafsdf
                      <v-icon v-on="on">mdi-alert-box</v-icon>
                    </template> -->
              </timeline-item>
            </drag>
          </template>
          <template v-slot:feedback="{ data }">
            <div class="item feedback" :key="data._id">
              <div :style="`background: #dddddd`" class="icon-action">
                <v-icon class="material-icons">{{ data.icon }} </v-icon>
              </div>
              <div class="baloon">
                <div class="box-action">
                  <div class="text-truncate title-action">
                    {{ data.text }}
                  </div>
                </div>
                <div class="pointer"></div>
              </div>
            </div>
          </template>
        </drop-list>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import { DropList, Drag } from "vue-easy-dnd";
import _ from "lodash";
import TimelineItem from "./TimelineNew";
import { createPlaylis } from "../../../services/playlists";
import { listLetreiros } from '@/services/letreiros'
export default {
  components: { DropList, Drag, TimelineItem },
  data: () => ({
    messages: [
      {
        from: "You",
        message: `Sure, I'll see you later.`,
        time: "10:42am",
        color: "deep-purple lighten-1",
      },
      {
        from: "John Doe",
        message: "Yeah, sure. Does 1:00pm work?",
        time: "10:37am",
        color: "green",
      },
      {
        from: "You",
        message: "Did you still want to grab lunch today?",
        time: "9:47am",
        color: "deep-purple lighten-1",
      },
    ],
    name: "",
    valid: false,
    fonteNoticia: "",
    tituloMateria: "",
    fileLink: "",
    templateImg: "",
    templateImgLogo: "",
    creditosImagem: "",
    templateBackgroundColor: "blue",
    type: "",
    time: 0,
    selectedLetreiro: null,
    searchLetreiro: '',
    loadingLetreiros: false,
    letreirosResults: [],
    letreirosLoaded: false
  }),
  computed: {
    filteredLetreiros() {
      return this.letreirosResults
    }
  },
  created() {
    this.debouncedSearchLetreiros = _.debounce(this.searchLetreiros, 300)
  },
  methods: {
    async searchLetreiros(term) {
      if (!term || term.length < 2 && (term != this.selectedLetreiro.name)) {
        await this.fetchLetreirosInitial()
        return
      }
      try {
        this.loadingLetreiros = true
        const response = await listLetreiros({ page: 1, limit: 20, search: term })
        const items = response && Array.isArray(response.items) ? response.items : []
        this.letreirosResults = items
        this.letreirosLoaded = true
      } catch (error) {
        console.error('Erro ao buscar letreiros:', error)
        this.$store.commit('failed', 'Erro ao buscar letreiros')
      } finally {
        this.loadingLetreiros = false
      }
    },
    async fetchLetreirosInitial() {
      if (this.letreirosLoaded) return
      try {
        this.loadingLetreiros = true
        const response = await listLetreiros({ page: 1, limit: 20 })
        const items = response && Array.isArray(response.items) ? response.items : []
        this.letreirosResults = items
        this.letreirosLoaded = true
      } catch (error) {
        console.error('Erro ao carregar letreiros:', error)
        this.$store.commit('failed', 'Erro ao carregar letreiros')
      } finally {
        this.loadingLetreiros = false
      }
    },
    handleLetreiroFocus() {
      if (!this.searchLetreiro) {
        this.fetchLetreirosInitial()
      }
    },
    truncateText(text) {
      return text && text.length > 50 ? text.substring(0, 50) + '...' : text
    },
    save() {
      const isValid = this.$refs.form.validate();
      if (!isValid) return;
      const defaultPosition = this.selectedLetreiro && this.selectedLetreiro.position
        ? this.selectedLetreiro.position.toUpperCase()
        : 'TOPO';
      const letreiroPayload = (position) => (this.selectedLetreiro
        ? {
          _id: this.selectedLetreiro._id,
          name: this.selectedLetreiro.name,
          fonts: this.selectedLetreiro.fonts,
          text: this.selectedLetreiro.text,
          position
        }
        : null);
      const items = this.$store.state.playlist.itemsSelected
        .filter((data) => data.text != 1)
        .map((item) => {
          const { letreiroPosition, ...rest } = item
          const position = letreiroPosition || defaultPosition
          return {
            ...rest,
            showLetreiro: !!item.showLetreiro,
            letreiro: letreiroPayload(position)
          }
        });

      if (!items.length)
        return this.$store.commit(
          "failed",
          "Nenhum ítem selecionado para esta playlist"
        );
      this.$store.state.playlist.newPlaylist = {
        type: this.type,
        items,
        user: this.$store.state.user,
        name: this.name,
        letreiro: this.selectedLetreiro ? this.selectedLetreiro._id : null,
      };
      this.$store.commit("setLoading", true)
      createPlaylis()
        .then(() => {
          this.$store.commit("success", "Playlist salva com sucesso!");
          this.$store.commit("setLoading", false)
          this.$router.push("/playlists/list");
        })
        .catch((err) => this.$store.commit("failed", "ERRO: " + err));
    },
    abort() {
      if (confirm("Descartar playlist?")) {
        this.$router.push("/playlists/list");
        this.$store.state.playlist.newPlaylist = {};
        this.$store.state.playlist.preview = {};
      }
    },
    reorder(e) {
      e.apply(this.$store.state.playlist.itemsSelected);
    },
    onInsert(event) {
      const propName =
        event.data.itemType == "Notícia" ? "itemsNews" : "itemsAds";
      
      // Adicionar propriedades showLetreiro e letreiroPosition
      const itemToInsert = { 
        ...event.data, 
        showLetreiro: true,
      };

      delete itemToInsert.letreiroPosition
      
      this.$store.state.playlist.itemsSelected.splice(
        event.index,
        0,
        itemToInsert
      );
      const index = _.findIndex(this.$store.state.playlist[propName], {
        _id: event.data._id,
      });
      this.$store.state.playlist[propName].splice(index, 1);
      if(event.data.name === "Previsão do Tempo"){
        const newObj = {...event.data};
        newObj._id = String(Date.now());
        this.$store.state.playlist.itemsNews.unshift(newObj)
      }
    },
  },
  watch: {
    searchLetreiro(value) {
      this.debouncedSearchLetreiros(value)
    },
    selectedLetreiro(value) {
      this.$store.state.playlist.selectedLetreiro = value || null
      const defaultPosition = value && value.position
        ? value.position.toUpperCase()
        : 'TOPO'
      this.$store.state.playlist.itemsSelected.forEach((item) => {
        if (item && item._id !== '1133' && item.showLetreiro) {
          this.$set(item, 'letreiroPosition', defaultPosition)
        }
      })
    },
    "$store.state.playlist.itemsSelected"(items) {
      try {
        const timeline = items.map(item => Object.assign({}, item))
        timeline.pop()
        const names = timeline.reduce((acc, item) => {
          acc[item.user.name.slice(0, 4)] = acc[item.user?.name.slice(0, 4)] ? acc[item.user?.name.slice(0, 4)] + 1 : 1
          return acc
        }, {})
        let name = ''
        Object.keys(names).forEach(key => {
          name += key + "_" + names[key] + '_'
        })
        name = name.split('')
        name.pop()
        this.name = name.join('')
      } catch (error) {
        console.error(error)
      }


    }
  }
};
</script>

<style scoped>
.playlist-panel {
  height: calc(100vh - 220px);
  min-height: 520px;
}

@media (max-width: 960px) {
  .playlist-panel {
    height: auto;
    min-height: 0;
  }
}
</style>
